module.exports = __webpack_public_path__ + "static/media/RESTAURANT-STANDARD-SERVICE-AGREEMENT.7c307051.pdf";